/*
imageContext.js

A context singleton for handling image objects and their associated data 
*/

import React, { createContext, useState } from 'react';

export const ImageContext = createContext({osdConfig: '', images: []})

export const ImageContextProvider = ({value, children}) => {

    const [ osdConfig, setOsdConfig ] = useState(value.osdConfig)
    const [ images, setImages ] = useState(value.images)

    return ( <ImageContext.Provider value={{osdConfig, images}}>
        {children}
    </ImageContext.Provider> )
}